"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const castNumberToCoordinate_1 = __importDefault(require("../../../shared/castNumberToCoordinate"));
const getNumberFromUnknownOrDefault_1 = __importDefault(require("../../../shared/getNumberFromUnknownOrDefault"));
const reduceValidMarkers = (markers) => {
    if (!(0, ts_validators_1.valueIsRecord)(markers)) {
        return null;
    }
    const markerEntries = Object.entries(markers);
    const allMarkers = markerEntries.map(([markerId, marker]) => {
        var _a;
        if (!(0, ts_validators_1.valueIsRecord)(marker)) {
            return null;
        }
        const latitudeValue = (0, castNumberToCoordinate_1.default)(marker.latitude);
        if (!latitudeValue) {
            return null;
        }
        const longitudeValue = (0, castNumberToCoordinate_1.default)(marker.longitude);
        if (!longitudeValue) {
            return null;
        }
        const degrees = (0, getNumberFromUnknownOrDefault_1.default)(marker.degrees, 0);
        const width = (0, getNumberFromUnknownOrDefault_1.default)(marker.width, 30);
        const height = (0, getNumberFromUnknownOrDefault_1.default)(marker.height, 30);
        const rotation = (0, getNumberFromUnknownOrDefault_1.default)(marker.rotation, 0);
        return {
            identifier: markerId,
            coordinate: {
                latitude: latitudeValue,
                longitude: longitudeValue,
            },
            title: (0, ts_validators_1.valueIsString)(marker.title) ? marker.title : markerId,
            description: ((_a = marker.description) === null || _a === void 0 ? void 0 : _a.toString()) || '',
            rotation,
            icon: (0, ts_validators_1.valueIsString)(marker.image) ? marker.image : undefined,
            width,
            height,
            degrees,
            marker,
        };
    });
    return allMarkers.filter((marker) => marker !== null);
};
exports.default = reduceValidMarkers;
